/**
 * Single source of truth for Accumulation Calculator What-If scenarios.
 * Uses the same runAccumulationSimulation path as main Run.
 */
import { SimulationEngine } from './SimulationEngine.js';

/** Build one-time contributions — mirrors handleCalculateWithInputs in working-accumulation.js */
export function buildAccumulationOneTimeContributions(inputData) {
  const oneTimeContributions = {
    user: { concessional: [], nonConcessional: [] },
    partner: { concessional: [], nonConcessional: [] },
  };

  for (let i = 1; i <= 5; i++) {
    const ccYear = inputData[`oneTimeCC_year${i}`];
    const ccAmount = inputData[`oneTimeCC_amount${i}`];
    if (ccYear && ccAmount) {
      oneTimeContributions.user.concessional.push({ year: ccYear, amount: ccAmount });
    }
    const nccYear = inputData[`oneTimeNCC_year${i}`];
    const nccAmount = inputData[`oneTimeNCC_amount${i}`];
    if (nccYear && nccAmount) {
      oneTimeContributions.user.nonConcessional.push({ year: nccYear, amount: nccAmount });
    }
  }

  for (let i = 1; i <= 5; i++) {
    const ccYear = inputData[`partnerOneTimeCC_year${i}`];
    const ccAmount = inputData[`partnerOneTimeCC_amount${i}`];
    if (ccYear && ccAmount) {
      oneTimeContributions.partner.concessional.push({ year: ccYear, amount: ccAmount });
    }
    const nccYear = inputData[`partnerOneTimeNCC_year${i}`];
    const nccAmount = inputData[`partnerOneTimeNCC_amount${i}`];
    if (nccYear && nccAmount) {
      oneTimeContributions.partner.nonConcessional.push({ year: nccYear, amount: nccAmount });
    }
  }

  if (inputData.downsizerContribution && inputData.downsizerYear) {
    oneTimeContributions.user.nonConcessional.push({
      year: inputData.downsizerYear,
      amount: inputData.downsizerContribution,
    });
  }
  if (inputData.partnerDownsizerContribution && inputData.partnerDownsizerYear) {
    oneTimeContributions.partner.nonConcessional.push({
      year: inputData.partnerDownsizerYear,
      amount: inputData.partnerDownsizerContribution,
    });
  }

  return oneTimeContributions;
}

export function runAccumulationScenario(inputData, oneTimeContributions) {
  return SimulationEngine.runAccumulationSimulation(inputData, oneTimeContributions);
}

export function runAccumulationExtraContributionWhatIf(snap, contributions, extraAmount) {
  const scenarioInputs = {
    ...snap,
    additionalContributions: (Number(snap.additionalContributions) || 0) + Number(extraAmount || 0),
  };
  return runAccumulationScenario(scenarioInputs, contributions);
}

export function runAccumulationLumpSumWhatIf(snap, contributions, amount, year) {
  const scenarioContributions = JSON.parse(JSON.stringify(contributions));
  scenarioContributions.user.nonConcessional.push({
    year: year || 1,
    amount: Number(amount || 0),
  });
  return runAccumulationScenario(snap, scenarioContributions);
}

export function runAccumulationFeeChangeWhatIf(snap, contributions, feeDeltaPctPts) {
  const scenarioInputs = {
    ...snap,
    investmentFees: (Number(snap.investmentFees) || 0) + Number(feeDeltaPctPts || 0),
  };
  return runAccumulationScenario(scenarioInputs, contributions);
}

export function getAccumulationBaselineMedian(accumulationResults) {
  return accumulationResults?.finalBalances?.median ?? null;
}

export function formatAccumulationWhatIfDelta(scenarioResult, baselineMedian) {
  if (baselineMedian == null || !scenarioResult?.finalBalances?.median) return null;
  const scenarioMedian = scenarioResult.finalBalances.median;
  const difference = scenarioMedian - baselineMedian;
  return {
    scenarioMedian: Math.round(scenarioMedian),
    baselineMedian: Math.round(baselineMedian),
    difference: Math.round(difference),
  };
}
